import { SharedListingData } from 'src/app/_shared/stores/listing/shared-listing.state';

const stateName = '[Shared][Listing] ';

export class SharedListingSaveAction {
    static readonly type = stateName + 'SharedListingSaveAction';
    constructor(public listingId: string, public informations: SharedListingData) {
    }
}


export class SharedListingResetAction {
    static readonly type = stateName + 'SharedListingResetAction';
    constructor(public listingId: string) {
    }
}
